import React, { useEffect, useState } from 'react';
import { Plus, Edit2, X, Check, Tag, Trash2 } from 'lucide-react';
import api from '../../api/client';
import { useAuth } from '../../context/AuthContext';
import { puoFare } from '../../utils/permessi';

const TAGLIE_PRESET = {
  'Abbigliamento': ['XS','S','M','L','XL','XXL'],
  'Calzature': ['36','37','38','39','40','41','42','43','44','45','46','47'],
  'Accessori': ['TU'],
};

export default function Categories() {
  const { user } = useAuth();
  const puoCreare     = puoFare(user, 'prodotti', 'create');
  const puoModificare = puoFare(user, 'prodotti', 'edit');
  const puoEliminare  = puoFare(user, 'prodotti', 'delete');
  const [categories, setCategories] = useState([]);
  const [showNew, setShowNew] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ nome: '', prefisso: '', taglie: [] });
  const [editForm, setEditForm] = useState({});
  const [newTaglia, setNewTaglia] = useState('');

  const load = () => api.get('/categories').then(r => setCategories(r.data));
  useEffect(() => { load(); }, []);

  const applyPreset = (preset) => {
    const taglie = TAGLIE_PRESET[preset] || [];
    setForm(f => ({ ...f, taglie }));
  };

  const addTaglia = (val, isEdit = false) => {
    const t = val.trim().toUpperCase();
    if (!t) return;
    if (isEdit) {
      setEditForm(f => ({ ...f, taglie: [...(f.taglie || []), t] }));
    } else {
      setForm(f => ({ ...f, taglie: [...(f.taglie || []), t] }));
    }
    setNewTaglia('');
  };

  const removeTaglia = (t, isEdit = false) => {
    if (isEdit) setEditForm(f => ({ ...f, taglie: f.taglie.filter(x => x !== t) }));
    else setForm(f => ({ ...f, taglie: f.taglie.filter(x => x !== t) }));
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      await api.post('/categories', form);
      setShowNew(false); setForm({ nome: '', prefisso: '', taglie: [] }); load();
    } catch (err) { alert(err.response?.data?.error || 'Categoria non salvata'); }
  };

  const handleUpdate = async (id) => {
    try {
      await api.put(`/categories/${id}`, editForm);
      setEditing(null); load();
    } catch (err) { alert(err.response?.data?.error || 'Modifiche non salvate'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Disattivare categoria?')) return;
    try { await api.delete(`/categories/${id}`); load(); }
    catch (err) { alert(err.response?.data?.error || 'Categoria non disattivata'); }
  };

  const startEdit = (cat) => {
    setEditing(cat.id);
    setEditForm({ nome: cat.nome, prefisso: cat.prefisso, taglie: cat.sizeGroups?.map(sg => sg.taglia) || [] });
  };

  return (
    <div>
      <div style={s.header}>
        <div>
          <h1 style={s.title}>CATEGORIE</h1>
          <p style={s.sub}>Gestisci le categorie e i set di taglie per ognuna</p>
        </div>
        {puoCreare && <button style={s.btnPri} onClick={() => setShowNew(true)}><Plus size={14} /> NUOVA CATEGORIA</button>}
      </div>

      {/* FORM NUOVA */}
      {showNew && (
        <div style={s.formCard}>
          <div style={s.formTitle}>NUOVA CATEGORIA</div>
          <form onSubmit={handleCreate} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
              <div style={s.field}><label style={s.label}>NOME *</label>
                <input style={s.input} value={form.nome} onChange={e => setForm(f => ({ ...f, nome: e.target.value }))} required /></div>
              <div style={s.field}><label style={s.label}>PREFISSO SKU * (max 5)</label>
                <input style={s.input} value={form.prefisso} onChange={e => setForm(f => ({ ...f, prefisso: e.target.value.toUpperCase().slice(0,5) }))} required placeholder="es. ABB" /></div>
            </div>

            <div style={s.field}>
              <label style={s.label}>PRESET TAGLIE</label>
              <div style={{ display: 'flex', gap: '8px' }}>
                {Object.keys(TAGLIE_PRESET).map(p => (
                  <button key={p} type="button" style={s.presetBtn} onClick={() => applyPreset(p)}>{p}</button>
                ))}
              </div>
            </div>

            <div style={s.field}>
              <label style={s.label}>TAGLIE</label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '8px' }}>
                {form.taglie.map(t => (
                  <div key={t} style={s.tagliaPill}>
                    {t}
                    <button type="button" style={s.removeT} onClick={() => removeTaglia(t)}><X size={10} /></button>
                  </div>
                ))}
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <input style={s.input} placeholder="Aggiungi taglia..." value={newTaglia}
                  onChange={e => setNewTaglia(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), addTaglia(newTaglia))} />
                <button type="button" style={s.btnSec} onClick={() => addTaglia(newTaglia)}>AGGIUNGI</button>
              </div>
            </div>

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button type="button" style={s.btnSec} onClick={() => setShowNew(false)}>ANNULLA</button>
              <button type="submit" style={s.btnPri}>CREA</button>
            </div>
          </form>
        </div>
      )}

      {/* LISTA */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {categories.map(cat => (
          <div key={cat.id} style={s.catCard}>
            {editing === cat.id ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', flex: 1 }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  <div style={s.field}><label style={s.label}>NOME</label>
                    <input style={s.input} value={editForm.nome} onChange={e => setEditForm(f => ({ ...f, nome: e.target.value }))} /></div>
                  <div style={s.field}><label style={s.label}>PREFISSO</label>
                    <input style={s.input} value={editForm.prefisso} onChange={e => setEditForm(f => ({ ...f, prefisso: e.target.value.toUpperCase().slice(0,5) }))} /></div>
                </div>
                <div style={s.field}>
                  <label style={s.label}>TAGLIE</label>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '8px' }}>
                    {(editForm.taglie || []).map(t => (
                      <div key={t} style={s.tagliaPill}>{t}<button type="button" style={s.removeT} onClick={() => removeTaglia(t, true)}><X size={10} /></button></div>
                    ))}
                  </div>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <input style={s.input} placeholder="Aggiungi taglia..." value={newTaglia}
                      onChange={e => setNewTaglia(e.target.value)}
                      onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), addTaglia(newTaglia, true))} />
                    <button type="button" style={s.btnSec} onClick={() => addTaglia(newTaglia, true)}>+</button>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                  <button style={s.btnSec} onClick={() => setEditing(null)}>ANNULLA</button>
                  <button style={s.btnPri} onClick={() => handleUpdate(cat.id)}><Check size={13} /> SALVA</button>
                </div>
              </div>
            ) : (
              <>
                <div style={s.catIcon}><Tag size={16} color="#F4600C" /></div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                    <span style={{ fontWeight: '700', fontSize: 'var(--font-size-base)' }}>{cat.nome}</span>
                    <span style={s.prefissoBadge}>{cat.prefisso}</span>
                    <span style={{ color: 'var(--text-dim)', fontSize: 'var(--font-size-xs)' }}>· SKU es: {cat.prefisso}-PRODOTTO-M</span>
                  </div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                    {cat.sizeGroups?.map(sg => (
                      <span key={sg.id} style={s.sizeChip}>{sg.taglia}</span>
                    ))}
                    {(!cat.sizeGroups || cat.sizeGroups.length === 0) && <span style={{ color: 'var(--text-dim)', fontSize: 'var(--font-size-xs)' }}>Nessuna taglia configurata</span>}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  {puoModificare && <button style={s.iconBtn} onClick={() => startEdit(cat)}><Edit2 size={13} /></button>}
                  {puoEliminare && <button style={{ ...s.iconBtn, color: '#EF4444' }} onClick={() => handleDelete(cat.id)}><Trash2 size={13} /></button>}
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

const s = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px' },
  title: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 'var(--font-size-title)', fontWeight: '800', letterSpacing: '2px' },
  sub: { color: 'var(--text-dim)', fontSize: 'var(--font-size-sm)', marginTop: '4px' },
  btnPri: { display: 'flex', alignItems: 'center', gap: '8px', background: '#F4600C', color:'#fff', border: 'none', borderRadius: '8px', padding: '10px 16px', fontSize: 'var(--font-size-xs)', fontWeight: '700', cursor: 'pointer' },
  btnSec: { background: 'var(--border)', color: 'var(--text)', border: '1px solid var(--border2)', borderRadius: '8px', padding: '8px 12px', fontSize: 'var(--font-size-xs)', fontWeight: '700', cursor: 'pointer' },
  formCard: { background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '12px', padding: '24px', marginBottom: '20px' },
  formTitle: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 'var(--font-size-sm)', fontWeight: '700', letterSpacing: '2px', marginBottom: '16px' },
  field: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: 'var(--font-size-xs)', letterSpacing: '2px', fontWeight: '700', color: 'var(--text-dim)' },
  input: { background: 'var(--bg-input)', border: '1px solid var(--border2)', borderRadius: '8px', padding: '9px 12px', color: 'var(--text)', fontSize: 'var(--font-size-sm)', outline: 'none' },
  presetBtn: { background: 'var(--bg-input)', border: '1px solid var(--border2)', borderRadius: '6px', padding: '6px 12px', color: 'var(--text-muted)', fontSize: 'var(--font-size-xs)', cursor: 'pointer' },
  tagliaPill: { display: 'flex', alignItems: 'center', gap: '6px', background: '#F4600C18', border: '1px solid #F4600C40', borderRadius: '6px', padding: '4px 10px', fontSize: 'var(--font-size-xs)', fontWeight: '700', color: '#F4600C' },
  removeT: { background: 'transparent', border: 'none', cursor: 'pointer', color: '#F4600C', display: 'flex', padding: 0 },
  catCard: { background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '10px', padding: '16px 20px', display: 'flex', alignItems: 'flex-start', gap: '14px' },
  catIcon: { width: '36px', height: '36px', background: '#F4600C15', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '2px' },
  prefissoBadge: { background: '#F4600C20', color: '#F4600C', border: '1px solid #F4600C40', borderRadius: '4px', padding: '2px 8px', fontSize: 'var(--font-size-xs)', fontWeight: '800', letterSpacing: '1px' },
  sizeChip: { background: 'var(--bg-input)', border: '1px solid var(--border2)', borderRadius: '4px', padding: '2px 8px', fontSize: 'var(--font-size-xs)', fontWeight: '700', color: 'var(--text-muted)' },
  iconBtn: { background: 'var(--bg-input)', border: '1px solid var(--border2)', borderRadius: '6px', padding: '7px 9px', color: 'var(--text-muted)', cursor: 'pointer', display: 'flex', alignItems: 'center' },
};
